import React from 'react';
import styled from 'styled-components';
import Radio from '@commoncomponents/frontend-components/dist/components/Radio';
import { breakpoints, fontSizes, } from '@commoncomponents/frontend-components/dist/styled';
import { Avatar, ducks } from 'autenti-components';
import { displayDate, sortAccountList, getPlanNameWithCapitalizedPlanType, } from '../../utils';
import { ListType } from '../../constants';
import CheckBox from '../CheckBox';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
const AccountsList = ({ header, youText, expirationText, expirationShortText, listType, accountsList, currentUserEmail, isMobileView, organizationCodeUser, handleChangeUserForPaymentState, setShowCodeInputBar, ORGANIZATION_ACTIVATION_CODES_ACTIONS: { SET_USER, CLEAR_PLAN_CHANGE_INFO }, ORGANIZATION_PAYMENT_ACTIONS: { UPDATE_SELECTED_USERS }, }) => {
    const sortedAccountsList = sortAccountList(accountsList, 'boxIdentifier', currentUserEmail);
    const displayPlanName = (currentPlanName, expirationDate) => {
        if (currentPlanName.includes('Free')) {
            return React.createElement(FreePlanInfo, null, currentPlanName);
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(PlanInfo, null, currentPlanName),
            React.createElement(ExpirationDate, null,
                isMobileView ? expirationShortText : expirationText,
                ' ',
                displayDate(expirationDate))));
    };
    const isAccountChecked = (account) => {
        switch (listType) {
            case ListType.CHECKBOX:
                return account.checked;
            case ListType.RADIO:
                return isUserForCodeActivation(account.boxIdentifier);
        }
    };
    const isCurrentUser = (userEmail) => userEmail === currentUserEmail;
    const isUserForCodeActivation = (userIdentifier) => organizationCodeUser
        ? organizationCodeUser.boxIdentifier === userIdentifier
        : false;
    return (React.createElement(Accounts, null,
        React.createElement(AccountListHeader, null, header),
        accountsList &&
            sortedAccountsList.map((account) => (React.createElement(AccountsListItem, { key: account.id, checked: isAccountChecked(account) },
                listType === ListType.CHECKBOX && (React.createElement(CheckBox, { checked: account.checked, onClick: (e) => handleChangeUserForPaymentState(account, e.target.checked) })),
                listType === ListType.RADIO && (React.createElement(Radio, { checked: isUserForCodeActivation(account.boxIdentifier), onChange: () => {
                        CLEAR_PLAN_CHANGE_INFO();
                        SET_USER(account);
                        UPDATE_SELECTED_USERS([account]);
                        if (isMobileView && !organizationCodeUser)
                            setShowCodeInputBar(true);
                    } })),
                React.createElement(Avatar, { givenName: account.givenName, surname: account.surname, emailText: account.boxIdentifier, youText: youText, isCurrentUser: isCurrentUser(account.boxIdentifier), showNameTooltip: true, showEmailTooltip: true }),
                account.planSubscription && (React.createElement(Info, null, displayPlanName(getPlanNameWithCapitalizedPlanType(account.planSubscription.name), account.planSubscription.expirationDate))))))));
};
const Accounts = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 265px;
  overflow-y: auto;
  overflow-x: hidden;

  @media ${breakpoints.md} {
    max-height: 100%;
  }
`;
const AccountListHeader = styled.div `
  flex: 0 0 auto;
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  color: #29333d;
  padding: 16px 24px 8px;

  @media ${breakpoints.md} {
    padding: 16px 16px 8px;
  }
`;
const AccountsListItem = styled.div `
  display: flex;
  padding: 12px 24px 11px 20px;
  align-items: center;
  border-bottom: 1px solid #e1e6ea;
  background-color: ${(props) => (props.checked ? '#F7F9FB' : '#fff')};
  min-height: 72px;

  .avatar-placeholder {
    background: #b2bdc8;
    @media (min-width: 769px) {
      font-size: ${fontSizes.subheading2};
      height: 40px;
      line-height: 40px;
      width: 40px;
    }
  }

  .avatar-email-wrapper {
    @media (min-width: 569px) {
      max-width: 250px;
    }
  }

  .radio-form-control-label {
    margin-right: 0;
  }

  @media ${breakpoints.md} {
    padding: 12px 16px 11px;
  }
`;
const Info = styled.div `
  font-size: 12px;
  display: flex;
  flex-direction: column;
  text-align: right;
  min-width: 170px;
  @media ${breakpoints.md} {
    min-width: 130px;
  }
`;
const PlanInfo = styled.div `
  color: #1872e7;
`;
const FreePlanInfo = styled.div `
  color: #29333d;
  margin-top: -23px;
`;
const ExpirationDate = styled.div `
  color: #899bad;
`;
export const mapStateToProps = (state) => ({
    organizationCodeUser: state.organizationActivationCodes.get('user'),
});
export const mapDispatchToProps = (dispatch) => ({
    ORGANIZATION_ACTIVATION_CODES_ACTIONS: bindActionCreators(ducks.ORGANIZATION_ACTIVATION_CODES_ACTIONS, dispatch),
    ORGANIZATION_PAYMENT_ACTIONS: bindActionCreators(ducks.ORGANIZATION_PAYMENT_ACTIONS, dispatch),
});
export default connect(mapStateToProps, mapDispatchToProps)(AccountsList);
